module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewIdCardPrintModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printIdCardPrintModal"
    }
  }, [_c('div', {
    staticClass: "card card-primary card-outline padding-sm",
    staticStyle: {
      "border-style": "solid",
      "padding": "6px 6px 6px 6px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    staticStyle: {
      "width": "65px",
      "height": "52px"
    },
    attrs: {
      "src": this.logo,
      "alt": "company logo"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getCompanyRecord.companyName) ? _c('div', [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-family": "Copperplate, Fantasy"
    }
  }, [_vm._v(_vm._s(_vm.getCompanyRecord.companyName.toUpperCase()))])]) : _vm._e()])]), _vm._v(" "), (_vm.empInfo.user) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-circle",
    staticStyle: {
      "height": "112px"
    },
    attrs: {
      "src": this.photo,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-bold"
  }, [_vm._v("\n                        " + _vm._s(_vm.empInfo.user.name.toUpperCase()) + "\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v("\n                       ( " + _vm._s(_vm.empInfo.designation.name.toUpperCase()) + " )\n                       ")]), _vm._v(" "), _c('b', [_vm._v("Employee Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.empInfo.user.code))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Phone Number")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.empInfo.user.mobile))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("City")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.empInfo.city))]), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.printIdCardPrintModal
    }
  }, [_vm._v("\n                PRINT\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n            ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Employee ID Card")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b66c330!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/EmployeeIdCard.vue
// module id = 865
// module chunks = 0